import { AlterResponse } from "../../models/AlterView";
import { View } from "../View";

export default class Q2_1 extends View {
    render() {
        return (
            <div className="Q2_1">
                <h2>Qui voulez-vous d'abord rencontrer ?</h2>
                <hr />
                <div className="btn-group">
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_1) }>Le sujet féminin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_2) }>Le sujet masculin</button>
                </div>
            </div>
        );
    }
}
